import { SAVE_DYNAMIC_ATTRIBUTE_GROUP } from "@/modules/dynamic-attributes/entities/group";
import { useNotification } from "@/shared/feedback/notification";
import { useMutation } from "@apollo/client";
import { useTranslations } from "use-intl";
import { FieldsType } from "./types";
import { GET_ENTITY_ATTRIBUTES } from "@/modules/dynamic-attributes/widgets/dynamic-attribute-editor/api/get-entity-attributes";

export function useSaveDynamicAttributeGroup({
  afterSubmit,
}: {
  afterSubmit?: () => void;
}) {
  const t = useTranslations("GroupForm");
  const notify = useNotification();

  const [saveGroup] = useMutation(SAVE_DYNAMIC_ATTRIBUTE_GROUP, {
    refetchQueries: [GET_ENTITY_ATTRIBUTES],
  });

  const save = async (group: FieldsType) => {
    await saveGroup({ variables: { group } });

    afterSubmit?.();

    notify?.success({
      message: t("Group saved"),
    });
  };

  return { save };
}
